import {
  ChatMessageAttachmentType,
  ChatMessagePayloadAttachment,
} from "@jugl-web/rest-api";
import { PlainButton } from "@jugl-web/ui-components";
import { getFileSizeLabel } from "@jugl-web/utils/utils/files";
import React, { useState } from "react";
import { getAttachmentIcon } from "@web-src/modules/chats/components/AttachmentPreview/utils";
import { ReactComponent as PlayIcon } from "@web-src/modules/chats/components/AttachmentPreview/assets/play.svg";

export const EmailAttachmentCard: React.FC<{
  attachment: ChatMessagePayloadAttachment;
  onClick: () => void;
}> = ({ attachment, onClick }) => {
  const [hasMediaError, setHasMediaError] = useState(false);
  const showImage =
    attachment.type === ChatMessageAttachmentType.image && !hasMediaError;
  const showVideo =
    attachment.type === ChatMessageAttachmentType.video && !hasMediaError;

  return (
    <PlainButton
      onClick={onClick}
      className="flex w-[140px] cursor-pointer flex-col gap-2 text-left"
    >
      <div className="flex h-20 w-full items-center justify-center overflow-hidden rounded-lg border border-solid border-dark-100 bg-gray-50">
        {showImage ? (
          <img
            src={attachment.url}
            alt={attachment.name}
            className="h-full w-full object-cover"
            onError={() => setHasMediaError(true)}
          />
        ) : showVideo ? (
          <div className="relative h-full w-full">
            <video
              src={attachment.url}
              className="h-full w-full object-cover"
              muted
              preload="metadata"
              onError={() => setHasMediaError(true)}
            />
            <div className="absolute inset-0 flex items-center justify-center bg-[rgba(26,32,35,0.50)] backdrop-blur-[2.5px]">
              <PlayIcon />
            </div>
          </div>
        ) : (
          <div className="flex h-10 w-10 items-center justify-center">
            {getAttachmentIcon(attachment.mimetype)}
          </div>
        )}
      </div>
      <div className="flex min-w-0 flex-col gap-0.5">
        <span className="truncate font-secondary text-sm font-medium text-dark-800">
          {attachment.name}
        </span>
        <span className="font-secondary text-xs text-[#828282]">
          {getFileSizeLabel(attachment.size)}
        </span>
      </div>
    </PlainButton>
  );
};
